import { useQuery } from '@apollo/client';

import { GetCompanyProfileDocument } from './companyProfile.gql';

export const useCompanyProfile = (companyProfileId?: string) => {
  // TODO: we could use useCompanyContext directly to if no argument is passed
  const { data, ...hook } = useQuery(GetCompanyProfileDocument, {
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId ?? '' },
  });

  return {
    company: data?.viewer?.company?.profile,
    ...hook,
  };
};
